import { defineMessages } from 'react-intl';

const subscriptionMessages = defineMessages({
    subscriptions: {
        id: 'subscriptions',
        defaultMessage: 'Subscriptions',
    },
    subscriptionPlans: {
        id: 'subscription-plans',
        defaultMessage: 'Subscription plans',
    },
    subscriptionPlan: {
        id: 'subscription-plan',
        defaultMessage: 'Subscription plan',
    },
    plans: {
        id: 'plans',
        defaultMessage: 'Plans',
    },
    plan: {
        id: 'plan',
        defaultMessage: 'Plan',
    },
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    cycleType: {
        id: 'cycle-type',
        defaultMessage: 'Cycle type',
    },
    cycleCount: {
        id: 'cycle-count',
        defaultMessage: 'Cycle count',
    },
    price: {
        id: 'price',
        defaultMessage: 'Price',
    },
    allowedHours: {
        id: 'allowed-hours',
        defaultMessage: 'Allowed hours',
    },
    allowedDays: {
        id: 'allowed-days',
        defaultMessage: 'Allowed days',
    },
    endType: {
        id: 'end-type',
        defaultMessage: 'End type',
    },
    language: {
        id: 'language',
        defaultMessage: 'Language',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    subscription: {
        id: 'subscription',
        defaultMessage: 'Subscription',
    },
    validFrom: {
        id: 'valid-from',
        defaultMessage: 'Valid from',
    },
    validTo: {
        id: 'valid-to',
        defaultMessage: 'Valid to',
    },
    subscriptionDetails: {
        id: 'subscription-details',
        defaultMessage: 'Subscription details',
    },
    subscriptionNumber: {
        id: 'subscription-number',
        defaultMessage: 'Subscription number',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    customer: {
        id: 'customer',
        defaultMessage: 'Customer',
    },
    entryRules: {
        id: 'entry-rules',
        defaultMessage: 'Entry rules',
    },
    entryFrom: {
        id: 'entry-from',
        defaultMessage: 'Entry from',
    },
    entryUntil: {
        id: 'entry-until',
        defaultMessage: 'Entry until',
    },
    backSubscriptions: {
        id: 'back-subscriptions',
        defaultMessage: 'Back to all subscriptions',
    },
    subscriptionHours: {
        id: 'subscription-hours',
        defaultMessage: '{value, plural, one {{value} (hour)} other {{value} (hours)}}',
    },
    subscriptionDays: {
        id: 'subscription-days',
        defaultMessage: '{value, plural, one {{value} (day)} other {{value} (days)}}',
    },
    subscriptionWeeks: {
        id: 'subscription-weeks',
        defaultMessage: '{value, plural, one {{value} (week)} other {{value} (weeks)}}',
    },
    subscriptionMonths: {
        id: 'subscription-months',
        defaultMessage: '{value, plural, one {{value} (month)} other {{value} (months)}}',
    },
    subscriptionYears: {
        id: 'subscription-years',
        defaultMessage: '{value, plural, one {{value} (year)} other {{value} (years)}}',
    },
    subscriptionUpcoming: {
        id: 'subscription-upcoming',
        defaultMessage: 'Upcoming',
    },
    subscriptionActive: {
        id: 'subscription-active',
        defaultMessage: 'Active',
    },
    subscriptionExpired: {
        id: 'subscription-expired',
        defaultMessage: 'Expired',
    },
    subscriptionHourly: {
        id: 'subscription-hourly',
        defaultMessage: 'Hourly',
    },
    subscriptionDaily: {
        id: 'subscription-daily',
        defaultMessage: 'Daily',
    },
    subscriptionWeekly: {
        id: 'subscription-weekly',
        defaultMessage: 'Weekly',
    },
    subscriptionMonthly: {
        id: 'subscription-monthly',
        defaultMessage: 'Monthly',
    },
    subscriptionYearly: {
        id: 'subscription-yearly',
        defaultMessage: 'Yearly',
    },
    endDay: {
        id: 'end-day',
        defaultMessage: 'End of day',
    },
    endCycle: {
        id: 'end-cycle',
        defaultMessage: 'End of cycle',
    },
    bulgarian: {
        id: 'bulgarian',
        defaultMessage: 'Bulgarian',
    },
    english: {
        id: 'english',
        defaultMessage: 'English',
    },
    editSubscriptionPlan: {
        id: 'edit-subscription-plan',
        defaultMessage: 'Edit subscription plan',
    },
    addSubscriptionPlan: {
        id: 'add-subscription-plan',
        defaultMessage: 'Add subscription plan',
    },
    deleteSubscriptionPlan: {
        id: 'delete-subscription-plan',
        defaultMessage: 'Delete subscription plan',
    },
    confirmDeleteSubscriptionPlan: {
        id: 'confirm-delete-subscription-plan',
        defaultMessage: 'Are you sure you want to delete the subscription plan {plan}? This action cannot be undone.',
    },
    editSubscriptionPlanDescription: {
        id: 'edit-subscription-plan-description',
        defaultMessage: 'Edit subscription plan details',
    },
    deleteSubscriptionPlanDescription: {
        id: 'delete-subscription-plan-description',
        defaultMessage: 'Permanently delete subscription plan',
    },
    createSubscriptionPlanDescription: {
        id: 'create-subscription-plan-description',
        defaultMessage: 'Create new subscription plan',
    },
    createSubscriptionPlanSuccess: {
        id: 'create-subscription-plan-success',
        defaultMessage: 'Subscription plan {plan_name} has been successfully created.',
    },
    updateSubscriptionPlanSuccess: {
        id: 'update-subscription-plan-success',
        defaultMessage: 'Subscription plan {plan_name} has been successfully updated.',
    },
    deleteSubscriptionPlanSuccess: {
        id: 'delete-subscription-plan-success',
        defaultMessage: 'Subscription plan {plan_name} has been successfully deleted.',
    },
    subscriptionStatus: {
        id: 'status',
        defaultMessage: 'Status',
    },
    subscriptionActivePeriod: {
        id: 'subscription-active-period',
        defaultMessage: 'Active period',
    },
    subscriptionFilterByActivePeriod: {
        id: 'subscription-filter-by-active-period',
        defaultMessage: 'Filter by active period',
    },
});

export default subscriptionMessages;
